import React, { useState } from "react";
import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import type { FieldValidation } from "@rjsf/utils";
import {
  FormControl,
  FormLabel,
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import { handleError } from "../../hooks/utils";
import { AxiosError } from "axios";

export const EnvVarField = ({
  required,
  onChange,
  formData,
  rawErrors,
}: FieldExtensionComponentProps<string>): JSX.Element => {
  const [values, setValues] = useState<{ name: string; value: string }[]>([]);
  const [rowIndex, setRowIndex] = useState<number>(0);
  const [rows, setRows] = useState<JSX.Element[]>([]);

  /**
   * Remove an item from the row list
   *
   * @param index number
   * @returns void
   */
  const handleRemoveClick = (index: number) => {
    if (index < 0) {
      handleError(new Error("Must be a positive index") as AxiosError);
      return;
    }

    document.getElementById(`row-${index}`)?.remove();
  };

  /**
   * Create a row
   *
   * @param index number The index of the row
   * @returns JSX.Element
   */
  const row = (index: number) => {
    return (
      <Grid container key={index} id={`row-${index}`}>
        <Grid item xs={5}>
          <TextField
            label="Key"
            required
            onChange={(event: any) => {
              const newValues = values;
              if (!newValues[index]) {
                newValues[index] = { name: "", value: "" };
              }
              newValues[index].name = event.target.value;
              setValues(newValues);
            }}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label="Value"
            required
            onChange={(event: any) => {
              const newValues = values;
              if (!newValues[index]) {
                newValues[index] = { name: "", value: "" };
              }
              newValues[index].value = event.target.value;
              setValues(newValues);
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Button onClick={() => handleRemoveClick(index)}>Remove</Button>
        </Grid>
      </Grid>
    );
  };

  /**
   * Add an item to the env var list
   *
   * @returns void
   */
  const handleAddClick = () => {
    if (rowIndex === 0) {
      const newRows = rows.concat(row(0));
      setRowIndex(1);
      setRows(newRows);
      return;
    }

    setRowIndex(rowIndex + 1);
    const newRows = rows.concat(row(rowIndex));
    setRows(newRows);
    return;
  };

  return (
    <>
      <FormLabel>Environment Variables</FormLabel>
      <FormControl
        margin="normal"
        required={required}
        error={rawErrors?.length > 0 && !formData}
        // @TODO: Fix this type issue, says can only be a string
        onChange={() => onChange(values as any)}
      >
        {rows}
        <Button id="add-new-env-var" onClick={handleAddClick}>
          + Add Env Variable
        </Button>
      </FormControl>
    </>
  );
};

export const envVarValidation = (value: any, validation: FieldValidation) => {
  if (Object.keys(value).includes("")) {
    validation.addError("empty keys are not allowed");
  }
};
